import { memeGrid } from "@/mocks/chigua";

export default function MemesSection() {
  return (
    <section id="memes" className="scroll-mt-28 bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-amber/20 px-3 py-1 text-xs font-bold text-[#a96f1f]">
              <i className="ri-emotion-laugh-line" />
              表情包 · 随事件二次传播
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              动图表情包 · 评论区直接用
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              每波热点都有专属表情包，按爆款程度分级，跟评论区节奏时随手挑一枚丢出去就很有画面感。
            </p>
          </div>
          <a
            href="#memes"
            className="flex items-center justify-center gap-2 whitespace-nowrap self-start rounded-full border border-sand bg-paper px-5 py-2.5 text-sm font-semibold text-ink/80 transition hover:bg-peach sm:self-auto"
          >
            表情包仓库
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {memeGrid.map((m) => (
            <a
              key={m.title}
              href="#memes"
              className="group overflow-hidden rounded-2xl bg-paper ring-1 ring-sand/60 transition hover:-translate-y-1"
            >
              <div className="relative aspect-square w-full overflow-hidden bg-sand">
                <img
                  src={m.cover}
                  alt={m.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-amber/90 px-2 py-0.5 text-[10px] font-bold text-ink">
                  {m.tag}
                </span>
                <span className="absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition group-hover:bg-black/20 group-hover:opacity-100">
                  <i className="ri-download-2-line text-2xl text-cream" />
                </span>
              </div>
              <p className="truncate px-3 py-2.5 text-xs font-medium text-ink/75">{m.title}</p>
            </a>
          ))}
        </div>

        <p className="mt-4 text-xs text-ink/40">
          <i className="ri-information-line mr-1" />
          表情包仅作传播使用，商用前请核对版权。
        </p>
      </div>
    </section>
  );
}